import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BaseComponent, ClassificatorValuesQuery, CONSTANTS, PropertiesQuery, SpecFilterOptions} from 'common-shared';
import {SpecLineFilterModel, SpecLineModel} from '../../../properties/models/spec-line.model';
import {FilterMatchMode} from "primeng/api";

@Component({
  selector: 'app-spec-values-list',
  templateUrl: './spec-values-list.component.html',
  styles: [':host {display: contents;}'],
})
export class SpecValuesListComponent extends BaseComponent {
  @Input() specs: SpecLineModel[] | SpecLineFilterModel[] = [];
  @Input() hasSpecFilterOptions: boolean = true;
  @Input() isMultiChoice: boolean = true;
  @Input() specFilterOptions: SpecFilterOptions = new SpecFilterOptions();
  @Input() cssClass: string = 'col-md-4';
  @Input() showLabel: boolean = true;
  @Input() showAdd: boolean = true;
  @Input() showRemove: boolean = false;
  @Input() propertyGroups: string[] = [];
  @Output() onLineChanged = new EventEmitter();
  @Output() onValueChanged = new EventEmitter<SpecLineModel>();
  @Output() onLineAdd = new EventEmitter();
  @Output() onLineRemoved = new EventEmitter<SpecLineModel>();
  @Output() edit = new EventEmitter<SpecLineModel>();
  Classificators = CONSTANTS;
  FilterMatchMode = FilterMatchMode;

  constructor(public propertiesQuery: PropertiesQuery, public classificatorValuesQuery: ClassificatorValuesQuery) {
    super();
  }

  addSpec() {
    this.onLineAdd.emit();
  }

  setMatchMode(matchMode: FilterMatchMode) {
    const equalityBasedModes: FilterMatchMode[] = [FilterMatchMode.EQUALS, FilterMatchMode.NOT_EQUALS];
    if (!equalityBasedModes.includes(this.specFilterOptions.MatchMode) || !equalityBasedModes.includes(matchMode)) {
      this.specs.forEach(spec => spec.resetValue());
    }
    this.specFilterOptions.MatchMode = matchMode;
    this.onLineChanged.emit();
  }
}
